













import { Component, Vue } from "vue-property-decorator";
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import moment from "moment";
import {
  GetPlanningItemsForProgressModeQuery,
  PlanningsClient,
  TeamAgendaDto,
  TeamsClient,
} from "@/data/web-api-client";

@Component({
  components: {
    FullCalendar,
  },
})
export default class ProgressMode extends Vue {
  private teams: TeamAgendaDto[] = [];

  data() {
    let self = this;
    return {
      calendarOptions: {
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        plugins: [interactionPlugin, resourceTimelinePlugin],
        height: window.innerHeight - 175,
        headerToolbar: {
          left: "",
          center: "title",
          right: "customToday prev,next",
        },
        views: {
          planner: {
            type: "resourceTimelineWeek",
            buttonText: "Planner",
            slotDuration: "1.00:00:00",
            duration: { days: 7 },
          },
        },
        customButtons: {
          customToday: {
            text: "Vandaag",
            click: function () {
              let calendar: any = self.$refs.fullCalendar;
              calendar.$options.calendar.gotoDate(
                moment().startOf("isoWeek").toDate()
              );
            },
          },
        },
        editable: false,
        initialView: "planner",
        firstDay: 0,
        weekends: true,
        locale: "nl",
        resourceAreaHeaderContent: "Teams",
        resourceAreaWidth: "15%",
        droppable: true,
        initialDate: moment().startOf("isoWeek").toDate(),
        resources: this.getResources,
        events: this.getEvents,
        eventContent: this.eventContent,
        eventDidMount: this.eventDidMount,
        resourceLaneContent: this.recourceRender,
      },
    };
  }

  //#region Calendar events

  private async getResources() {
    this.teams = await new TeamsClient(
      undefined,
      this.$axios
    ).getAllTeamsForAgenda();
    return this.teams;
  }

  private async getEvents(view: any) {
    var events = await new PlanningsClient(
      undefined,
      this.$axios
    ).getAgendaItemsForProgressMode(
      new GetPlanningItemsForProgressModeQuery({
        start: view.start,
        end: view.end,
      })
    );

    events.forEach((x) => {
      x.end = moment(x.end).add(12, "hours").toDate();
    });

    return events;
  }

  private eventContent(event: any) {
    event.textColor = "black";
    event.borderColor = event.event._def.extendedProps.eventBackgroundColor;
    event.backgroundColor = event.event._def.extendedProps.eventBackgroundColor;
    event.timeText = "";
  }

  private eventDidMount(event: any) {
    var contentElement: any = $(event.el).find(".fc-timeline-event");
    var mainDiv: any =
      contentElement.prevObject[0].getElementsByClassName("fc-event-main");

    if (event.event.extendedProps.newVisitNeeded == true) {
      var item: any = mainDiv[0].getElementsByClassName(
        "fc-event-title-container"
      );
      $(
        "<i style='color: orange; margin-left: 5px; margin-top: 3px' class='tooltipWarning fas fa-info-circle'><span class='tooltipWarningText'>Nieuw bezoek nodig!</span></i>"
      ).appendTo(item);
    }

    $(mainDiv[0]).css("margin-left", "10px");

    var outerDivProgressbar = $(document.createElement("div"));
    $(outerDivProgressbar).addClass("row");

    var innerDivProgressbar = $(document.createElement("div"));
    $(innerDivProgressbar).addClass("progress");
    $(innerDivProgressbar)
      .css("width", "50%")
      .css("height", "4px")
      .css("margin-left", "15px")
      .css("margin-top", "7px");
    $(
      "<div class='progress-bar' role='progressbar' aria-valuenow=" +
        event.event.extendedProps.measuringStateProgress +
        " aria-valuemin='0' aria-valuemax='100' style='background-color: black;width:" +
        event.event.extendedProps.measuringStateProgress +
        "%'></div>"
    ).appendTo(innerDivProgressbar);

    $(innerDivProgressbar).appendTo(outerDivProgressbar);
    $(
      "<div class='tooltipProgress' style='margin-left: 10px; margin-right:2px'>" +
        event.event.extendedProps.measuringStateProgress +
        "%<span class='tooltipProgressText'>Meetstaat voortgang</span></div>" +
        " | " +
        " <div class='tooltipTime' style='margin-left:2px'>" +
        event.event.extendedProps.timeProgress +
        "%<span class='tooltipTimeText'>Tijd van start tot laatste verslag, tegenover totale planning item tijd. Laatste verslag: " +
        this.convertDate(event.event.extendedProps.lastVisit) +
        "</span></div>"
    ).appendTo(outerDivProgressbar);


    //     var degreeRight;
    //     var degreeLeft;
    //     if (event.event.extendedProps.timeProgress < 50) {
    //       degreeRight = (180 / 50) * event.event.extendedProps.timeProgress;
    //       degreeLeft = 0;
    //     } else {
    //       degreeLeft = (180 / 50) * (event.event.extendedProps.timeProgress - 50);
    //       degreeRight = 180;
    //     }

    //     const css = Array.from(document.styleSheets).filter(
    //       (styleSheet) =>
    //         !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
    //     );
    //     css[css.length - 1].insertRule(
    //       `
    // @keyframes transform1 {
    //   0% {
    //     -webkit-transform: rotate(0deg);
    //     transform: rotate(0deg);
    //   }

    //   100% {
    //     -webkit-transform: rotate(` +
    //         degreeRight +
    //         `deg);
    //     transform: rotate(` +
    //         degreeRight +
    //         `deg);
    //   }
    // }`,
    //       css[css.length - 1].cssRules.length
    //     );

    //     css[css.length - 1].insertRule(
    //       `
    // @keyframes transform2 {
    //   0% {
    //     -webkit-transform: rotate(0deg);
    //     transform: rotate(0deg);
    //   }

    //   100% {
    //     -webkit-transform: rotate(` +
    //         degreeLeft +
    //         `deg);
    //     transform: rotate(` +
    //         degreeLeft +
    //         `deg);
    //   }
    // }`,
    //       css[css.length - 1].cssRules.length
    //     );

    //     var outerDivCircleProgressbar = $(document.createElement("div"));
    //     $(outerDivCircleProgressbar).addClass("d-flex justify-content-end mt-100");
    //     $(
    //       "<div class='progressCircle blue'><span class='progress-left'><span class='progress-bar' style='animation: transform2 linear 1s forwards 1s'></span></span><span class='progress-right'><span class='progress-bar' style='animation: transform1 linear 1s forwards'></span> </span><div class='progress-value' style='background-color: " +
    //         event.backgroundColor +
    //         "'>" +
    //         event.event.extendedProps.timeProgress +
    //         "%</div></div>"
    //     ).appendTo(outerDivCircleProgressbar);
    //     $(outerDivCircleProgressbar).appendTo(outerDivProgressbar);

    $(mainDiv[0]).append(outerDivProgressbar);
  }

  private recourceRender(resource: any) {
  }

  private convertDate(date: Date) {
    return moment(date).format("DD-MM-YYYY HH:mm");
  }

  //#endregion
}
